import api from "api";
import React, { useEffect, useMemo, useState } from "react";
import { connect } from "react-redux";
import stateMap from "store/stateMap";
import ComponentMonitorListInitiativeStatus from "component/Monitor/ListInitiativeStatus";
import ComponentMonitorListRole from "component/Monitor/ListRole";
import BlockHeader from "component/BlockHeader/BlockHeader";
import { useFormik } from "formik";
import { Link } from "react-router-dom";
import LoginBox from "component/LoginBox/LoginBox";
import fancybox from "component/Fancybox/Fancybox";
import { popinfo } from "component/Fancybox/Fancybox";

export default connect(stateMap)((props) => {

    const [isEligible, setIsEligible]   = useState(false);
    const [searchEmail, setSearchEmail] = useState('');
    const listArgs = useMemo(() => {
        return {
            initiator_email : searchEmail
        }
    }, [searchEmail])
    const formik = useFormik({
        initialValues: {
            search : ''
        }
        ,onSubmit : (values) => {
            setSearchEmail(values.search);
            
        }
    });

    useEffect(() => {
        if(!props.auth.token)
        {
            return;
        }

        api('/Monitor/Eligible','get',{}, 'Bearer ' + props.auth.token)
            .then((response) => {
                
                setIsEligible(response.isEligible);

            });
        
    }, [props.auth.token])

    return (
        <div className="page-sa container">
            {
                isEligible && <>
                    <BlockHeader title="Student Affairs Monitoring" desc="Monitor progress pembuatan initiative oleh user-user didalam crowdbees"/>
                    <form 
                        onSubmit={formik.handleSubmit}
                        className="generic-form popup-manage-member-search-member mb-4">
                        <input 
                            type="text"
                            name="search"
                            className="form-control text" 
                            placeholder="Search initiative by creator email"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            
                        />
                        <div className="text-right">
                            <input type="submit" className="btn btn-orange" value="Search"/>

                        </div>
                    </form>
                    <ComponentMonitorListInitiativeStatus args={ listArgs }/> 
                    <hr/>
                    <h4 className="text-lg font-semibold mb-md mt-md">List of Roles</h4>
                    <ComponentMonitorListRole args={ listArgs }/>
                    <hr/>
                    <h4 className="text-lg font-semibold mb-md mt-md">Survey Participant</h4>
                    <button className="btn btn-orange btn" onClick={e => {
                        e.preventDefault();
                        let RequestDownload = popinfo('loading', 'Export SAT', 'Please Wait');
            
                        api('/Survey/ExportParticipant', 'post', {

                        }, 'Bearer ' + props.auth.token)
                            .then(response => {
                                RequestDownload.close();
                                let element = document.createElement('a');
                                element.setAttribute('href', response.url);
                                element.setAttribute('download', response.name);
                                element.style.display = 'none';
                                document.body.appendChild(element);
                                element.click();
                                document.body.removeChild(element);
                            })
                            .catch(error => {
                                popinfo('error', 'Export SAT', error, {}, RequestDownload);
                            });
                    }}>Download Survey Participant</button>
                </>
            }
            {
                !isEligible &&
                <div className="text-lg text-center">You are not eligible to see this page 
                <div className="mt-4">
                    {
                        props.auth.token && <Link to="/" className="btn btn-orange">Return to Homepage</Link> 
                    }
                    {
                        !props.auth.token && 
                        <button 
                            className="btn btn-login btn-sm btn-white"
                            onClick={() => {
                                fancybox(<LoginBox/>);
                            }}
                        >Login to Crowdbees</button>
                    }
                </div>
                </div>
            }
        </div>
    )
});